import * as React from "react";
import {motion} from "framer-motion"

function SvgComponent(props) {
  return (
    <svg width={"100%"} viewBox="0 0 924.67 848.51" {...props}>
      <g id="loginbackground__Layer_2" data-name="Layer 2">
        <g id="loginbackground__Layer_1-2" data-name="Layer 1">
          <path
            fill="gray"
            opacity={0.2}
            d="M91.12 364.19l409.57 221.39 360.54-185.59-395.6-205.6-374.51 169.8z"
          />
          <motion.path
          animate={{y:20}}
          transition={{duration:3,yoyo:Infinity}}
            fill="gray"
            opacity={0.2}
            d="M75.23 405.71L484.81 627.1l360.54-185.58-395.6-205.61-374.52 169.8z"
          />
          <motion.path
          animate={{y:[0,10,0]}}
          transition={{duration:2,loop:Infinity}}
            id="loginbackground__box6"
            fill="gray"
            opacity={0.2}
            d="M32.98 192.24l35.07 18.96 30.88-15.89-33.88-17.61-32.07 14.54z"
          />
          <motion.path
          animate={{y:[0,10,0]}}
          transition={{duration:2,loop:Infinity}}
            id="loginbackground__box5"
            fill="#c1272d"
            opacity={0.2}
            d="M0 646.1l45.82 24.77 40.34-20.76L41.9 627.1 0 646.1z"
          />
          <motion.path
          animate={{y:[0,10,0]}}
          transition={{duration:2,loop:Infinity}}
            id="loginbackground__box4"
            fill="gray"
            opacity={0.7}
            d="M323.24 813.74l64.33 34.77 56.62-29.14-62.13-32.29-58.82 26.66z"
          />
          <motion.path
          animate={{y:[0,10,0]}}
          transition={{duration:2,loop:Infinity}}
            id="loginbackground__box1"
            fill="#c1272d"
            opacity={0.4}
            d="M705.38 136.66l64.32 34.77 56.62-29.15-62.13-32.29-58.81 26.67z"
          />
          <motion.path
          animate={{y:[0,10,0]}}
          transition={{duration:2,loop:Infinity}}
            id="loginbackground__box2"
            fill="gray"
            opacity={0.4}
            d="M842.36 345.51l43.78 23.66 38.53-19.84-42.28-21.97-40.03 18.15z"
          />
          <motion.path
          animate={{y:[0,10,0]}}
          transition={{duration:2,loop:Infinity}}
            id="loginbackground__box3"
            fill="#c1272d"
            opacity={0.3}
            d="M652.46 687.94l40.64 21.97 35.78-18.42-39.26-20.4-37.16 16.85z"
          />
          <path
            id="loginbackground__screen3"
            fill="#e50000"
            opacity={0.5}
            d="M528 263.12l-351 172.5V172.5L528 0v263.12z"
          />
          <path
            id="loginbackground__screen2"
            fill="#e50000"
            opacity={0.5}
            d="M549.12 293.29l-350.99 172.5V202.67l350.99-172.5v263.12z"
          />
          <path
            d="M258.33 408.19l109.32-56s-6.92 54.31 5.18 91.67 13.5 83.72 13.5 83.72l-113.7 51.88s2.31-57.42-8.24-94.09-6.06-77.18-6.06-77.18z"
            fill="#e50000"
            opacity={0.1}
          />
          <g id="loginbackground__screen">
            <path
              fill="#333"
              d="M571.56 305.08l-350.99 172.5V232.67l350.99-172.5v244.91z"
            />
            <path
              fill="#fff"
              d="M266.46 266.49l91.83-45.4v137.33l-91.83 45.4V266.49zM487.88 160.18a7.06 7.06 0 01-3.88 6.31l-77.65 39.38a7.08 7.08 0 01-10.28-6.32v-1a7.06 7.06 0 013.94-6.34l77.65-38.41a7.08 7.08 0 0110.22 6.38zM457.52 218.29a7.1 7.1 0 01-3.87 6.32l-47.3 24.15a7.08 7.08 0 01-10.28-6.31v-1a7.08 7.08 0 013.94-6.35L447.3 212a7.08 7.08 0 0110.22 6.29zM457.52 300.38a7.07 7.07 0 01-3.87 6.31l-47.3 24.16a7.08 7.08 0 01-10.28-6.32v-1a7.06 7.06 0 013.94-6.34L447.3 294a7.08 7.08 0 0110.22 6.38zM487.88 246a7.06 7.06 0 01-3.88 6.31l-77.65 39.38a7.08 7.08 0 01-10.28-6.32v-1A7.06 7.06 0 01400 278l77.65-38.41a7.08 7.08 0 0110.23 6.41z"
            />
            <g fill="#e50000">
              <path d="M308.7 270.31c7.34-3.27 14 2.79 15 13.51s-4.24 22.09-11.57 25.35-14-2.8-14.94-13.55 4.2-22.06 11.51-25.31zM312.48 313.75a13.54 13.54 0 0115.31 2.35c4.21 3.79 7.17 10.32 7.89 18.63l.94 10.73-41.14 18.31-.93-10.72c-1.45-16.64 6.58-34.25 17.93-39.3z" />
            </g>
          </g>
          <path
            id="loginbackground__paper"
            d="M273.42 408.19l109.31-56s-6.92 54.31 5.19 91.67 13.49 83.72 13.49 83.72l-113.69 51.84s2.3-57.42-8.25-94.09-6.05-77.14-6.05-77.14z"
            fill="#f2f2f2"
          />
          <g id="loginbackground__tickbox">
            <ellipse
              cx={224.26}
              cy={202.81}
              rx={53.45}
              ry={38.89}
              transform="rotate(-79.13 224.272 202.808)"
              fill="#999"
            />
            <ellipse
              cx={235.3}
              cy={204.93}
              rx={53.45}
              ry={38.89}
              transform="rotate(-79.13 235.313 204.924)"
              fill="#ccc"
            />
            <path
              d="M231.86 230.91a3 3 0 01-1.39-.67l-18-15.43a3 3 0 013.93-4.58l15 12.88 19.25-39.6a3 3 0 115.43 2.64l-21 43.12a3 3 0 01-2.1 1.63 2.81 2.81 0 01-1.12.01z"
              fill="#fff"
              id="loginbackground__tick"
            />
          </g>
          <path
            id="loginbackground__card"
            fill="#e50000"
            d="M444.19 433.83l107.47 61.58 85.56-42.44L528 391.17l-83.81 42.66z"
          />
          <path
            d="M528.41 460.74a2.5 2.5 0 01-1.22-4.69l42.12-23.39a2.5 2.5 0 012.43 4.38l-42.12 23.38a2.52 2.52 0 01-1.21.32zM538.72 466.36a2.5 2.5 0 01-1.22-4.69l42.12-23.38a2.5 2.5 0 012.43 4.37L539.93 466a2.41 2.41 0 01-1.21.36zM549.12 472.43a2.5 2.5 0 01-1.21-4.69L590 444.36a2.5 2.5 0 012.43 4.37l-42.12 23.38a2.41 2.41 0 01-1.19.32z"
            fill="#fff"
          />
  
          <motion.g id="loginbackground__Lock"
          
          animate={{y:[0,30,0]}}
          transition={{duration:5,loop:Infinity}}
          
          >
            <path
              d="M765.55 247.4a4.33 4.33 0 01-.93 1h-.06a9.09 9.09 0 01-1.52 1l-.12.06a17.39 17.39 0 01-2.19.89c-.49.17-1.05.3-1.59.44s-1.23.32-1.89.46l-1.29.24c-.67.11-1.35.21-2.05.29s-1.24.16-1.88.22h-.24c-1 .08-2 .13-3.08.15h-3.4c-1-.05-2.07-.13-3.07-.24h-.05c-1-.11-1.94-.26-2.85-.44h-.13a25.35 25.35 0 01-2.6-.64l-85.09-44.69c-.48-.15-.85-.31-1.25-.47s-.63-.22-.88-.34a7.36 7.36 0 01-.93-.55 6.13 6.13 0 01-.57-.34 3.4 3.4 0 01-.62-.65c-.09-.11-.23-.21-.3-.32a2 2 0 01-.31-1l-1.38 142.86a2 2 0 00.32 1c.07.1.21.2.3.31a3.66 3.66 0 00.61.65c.17.13.41.24.6.36a8.42 8.42 0 00.91.54c.26.12.61.23.91.35s.73.3 1.17.44l85.09 44.69q.62.19 1.29.36l1.15.26a.76.76 0 01.16 0h.14l.77.14 1 .16c.32 0 .65.09 1 .12h.13l.85.08 1 .08q.49 0 1 .06h5.26l1.23-.08h.44l1.1-.1.78-.11c.7-.09 1.38-.19 2.05-.3q.66-.11 1.29-.24c.66-.13 1.28-.29 1.89-.45.26-.07.56-.12.81-.2l.78-.25c.25-.08.49-.16.72-.25s.69-.27 1-.41l.46-.23.12-.06.17-.08.6-.34.5-.33.25-.2.06-.05.1-.08a3.59 3.59 0 00.35-.32l.28-.33c.07-.1.14-.2.2-.3a2.11 2.11 0 00.16-.34 1.54 1.54 0 00.1-.35 2.4 2.4 0 000-.37l1.38-142.85a2 2 0 01-.21 1.09z"
              fill="red"
            />
            <path
              d="M761 242.65c6.59 2 6.48 5.49-.26 7.75s-17.53 2.45-24.12.44l-85.09-44.69c-6.59-2-6.48-5.48.25-7.74s17.54-2.47 24.13-.45z"
              fill="#a60000"
            />
            <path
              d="M733.32 240.05a6 6 0 01-6-6v-48.14a21 21 0 00-21.16-20.75 17.3 17.3 0 00-17.45 17.1v28.62a6 6 0 01-12.07 0v-28.62a29.38 29.38 0 0129.52-29.17 33.06 33.06 0 0133.23 32.82V234a6 6 0 01-6.07 6.05zM717.16 305v-1.31-.4-.42-.56c0-.48-.06-1-.1-1.45v-.05q-.07-.79-.18-1.59c0-.24-.08-.47-.12-.71s-.07-.41-.1-.62 0-.32-.08-.48c-.09-.43-.19-.84-.29-1.26-.06-.24-.1-.48-.17-.72a1.16 1.16 0 000-.18c0-.17-.11-.33-.16-.5-.22-.79-.47-1.56-.74-2.32 0-.14-.09-.29-.14-.43s-.16-.36-.23-.54c-.23-.56-.46-1.1-.72-1.65-.14-.31-.29-.62-.44-.93-.29-.57-.6-1.12-.92-1.67-.11-.19-.2-.4-.32-.59l-.1-.14a27.45 27.45 0 00-1.72-2.49l-.12-.19c-.26-.32-.53-.63-.8-.94s-.31-.39-.48-.57l-.09-.12c-.39-.43-.8-.85-1.21-1.26l-.16-.14-.28-.26c-.22-.21-.44-.42-.67-.61l-.76-.64-.18-.14-.09-.08c-.34-.26-.67-.51-1-.75-.18-.13-.36-.24-.55-.36l-.23-.16-.21-.14q-.47-.3-1-.57l-.55-.29-.2-.11-.21-.11c-.32-.16-.64-.3-1-.44l-.65-.27-.17-.07-.15-.06-1-.34-.79-.22H697.87l-1-.23c-.29-.06-.58-.1-.86-.14H695.79c-.38-.05-.77-.09-1.16-.12s-.58 0-.88 0h-.35c-.44 0-.88 0-1.32.06-.16 0-.31 0-.47.06l-.5.06c-.18 0-.37 0-.55.08a14.21 14.21 0 00-1.47.32l-5.39 1.47a16.78 16.78 0 012-.4l.5-.06a15.11 15.11 0 012.14-.11 18.73 18.73 0 012.12.16h.13a19 19 0 012 .41h.13c.64.18 1.29.39 1.92.63l.17.07c.61.24 1.22.52 1.81.82l.21.11c.59.31 1.16.64 1.72 1l.23.15c.56.37 1.12.77 1.66 1.2l.17.14c.49.39 1 .81 1.43 1.24l.29.27c.5.48 1 1 1.46 1.51.17.19.32.39.48.58.32.37.62.74.92 1.12a29.09 29.09 0 011.72 2.5c.15.24.28.48.42.72.32.55.63 1.1.92 1.68.15.3.3.62.44.93q.38.81.72 1.65c.12.32.25.64.36 1 .28.76.53 1.54.75 2.33.07.23.14.45.2.68s.11.49.17.73c.13.57.26 1.14.37 1.73 0 .2.07.41.1.62.12.76.23 1.52.3 2.3s.09 1.38.11 2.06V307.12c0 .66-.09 1.31-.17 2a.22.22 0 000 .08c-.09.64-.19 1.28-.32 1.9v.18c-.13.6-.27 1.19-.43 1.77l-.09.31c-.16.56-.34 1.12-.54 1.66l-.12.31c-.19.5-.39 1-.61 1.47l-.09.2c-.24.52-.5 1-.77 1.5-.09.16-.18.3-.27.45-.19.34-.4.66-.61 1l-.43.62c-.17.24-.35.47-.53.7s-.51.64-.78.94l-.5.54c-.45.47-.92.92-1.41 1.34l-.17.15a16.15 16.15 0 01-1.73 1.25l-.51.3a15.79 15.79 0 01-1.41.74c-.19.09-.37.18-.57.26a15.31 15.31 0 01-2 .71l5.39-1.47a16 16 0 002-.72l.56-.26a15.79 15.79 0 001.41-.74l.51-.3a16.15 16.15 0 001.73-1.25l.17-.15c.49-.42 1-.87 1.41-1.34a1.8 1.8 0 00.2-.19c.11-.11.2-.24.3-.35.27-.3.53-.62.78-.94.09-.11.19-.21.28-.33s.17-.25.25-.37.29-.41.43-.62l.27-.38c.12-.2.23-.4.34-.6l.27-.44a1.59 1.59 0 01.13-.22c.21-.39.41-.79.61-1.2v-.08l.09-.2c.13-.3.27-.6.39-.9s.15-.38.22-.57l.12-.32a2.34 2.34 0 00.09-.24c.14-.37.26-.75.37-1.13a2.45 2.45 0 00.08-.29l.09-.31.15-.53c.09-.37.18-.75.26-1.13v-.1a1.06 1.06 0 010-.19c0-.28.11-.57.15-.85s.11-.7.16-1.05a.15.15 0 010-.07c0-.4.09-.8.13-1.2v-.73-.28c0-.09.1-.36.11-.46z"
              fill="#333"
            />
            <path
              d="M688.36 276c11.6.2 22 12 23.31 26.29s-7.12 25.8-18.72 25.59-22-12-23.28-26.32 7.11-25.74 18.69-25.56z"
              fill="#4d4d4d"
            />
            <path
              d="M692 283.77c-4.18-1.08-7.84 2.11-8.21 7.14a11.45 11.45 0 003.4 9l-2.67 19 9.62 2.48.15-19.68c2.48-.91 4.31-3.48 4.56-6.94.37-5-2.7-10-6.85-11"
              fill="#faf8fd"
            />
          </motion.g>
          <g fill="#fff">
            <path d="M522.25 431.9c2.72-1.39 6.59-1.85 10.65-1.46a30 30 0 0111.77 3.56l4.45 2.53-19.72 10.07-4.4-2.53c-7-3.95-8.2-9.4-2.75-12.17zM504.17 421.61c3.51-1.79 10-1.17 14.45 1.37s5.24 6 1.73 7.83-10 1.18-14.44-1.36-5.25-6.05-1.74-7.84z" />
          </g>
          <path
            d="M356.09 397.68c1.73-.7 3.86 1.5 4.73 4.91s.17 6.76-1.57 7.46l-57.17 23.1c-1.75.71-3.85-1.48-4.73-4.92s-.18-6.75 1.57-7.46z"
            fill="#ff9f50"
          />
          <path
            d="M350 426.28c.87-.35 1.93.75 2.37 2.46s.08 3.37-.79 3.72L318 446c-.87.35-1.93-.75-2.37-2.45s-.08-3.38.79-3.73z"
            fill="#e6e6e6"
          />
          <path
            d="M359.85 487.28c.87-.35 2.36 2.43 3.33 6.23s1.05 7.13.18 7.48l-33.58 13.57c-.87.35-2.36-2.43-3.33-6.21s-1.05-7.15-.18-7.51z"
            fill="#4ad1f0"
          />
          <path
            d="M351.76 467.43c.87-.35 1.93.75 2.36 2.45s.09 3.38-.78 3.73l-33.58 13.57c-.87.35-1.93-.75-2.37-2.46s-.08-3.37.79-3.73zM350 447.54c.87-.35 1.93.75 2.36 2.46s.09 3.38-.78 3.73L318 467.3c-.87.35-1.92-.73-2.37-2.46s-.08-3.38.79-3.73zM368.62 509.15c1.16-.46 2.88 2.25 3.85 6s.82 7.24-.34 7.71L327.34 541c-1.16.47-2.88-2.25-3.85-6s-.82-7.25.34-7.72z"
            fill="#e6e6e6"
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgComponent;

